import type * as React from 'react';
import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import { type MainMenuProps, useMe, useUITheme } from '@crehana/web';
import DashboardMenu from '@crehana/web/DashboardMenu';
import { MAIN_MENU_TRANSLATION_KEY } from '@crehana/web/MainMenu/constants';

import useCannyUrl from './useCannyUrl';

const DashboardMenuWrapper: FC<
  React.PropsWithChildren<Omit<MainMenuProps, 'countryPrefix'>>
> = ({
  customLocales: customLocalesProp,
  // isAnonymous,
  // disableAuthDialog,
  // topBannerProps,

  ...mainMenuProps
}) => {
  const cannyUrl = useCannyUrl();

  const { me } = useMe();
  const { theme, toggleTheme } = useUITheme();

  const { countryCode } = useTranslation();

  return (
    <DashboardMenu
      {...mainMenuProps}
      feedbackUrl={me?.hasOrganization ? cannyUrl : undefined}
      userTheme={theme}
      onToggleUserTheme={toggleTheme}
      countryPrefix={countryCode || ''}
      customLocales={{
        es: {
          [MAIN_MENU_TRANSLATION_KEY]: {
            // ...customLocales.es?.[MAIN_MENU_TRANSLATION_KEY],
            ...customLocalesProp?.es?.[MAIN_MENU_TRANSLATION_KEY],
          },
        },
        pt: {
          [MAIN_MENU_TRANSLATION_KEY]: {
            // ...customLocales.pt?.[MAIN_MENU_TRANSLATION_KEY],
            ...customLocalesProp?.pt?.[MAIN_MENU_TRANSLATION_KEY],
          },
        },
      }}
    />
  );
};

export default DashboardMenuWrapper;
